/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Inject, Injectable} from '@angular/core';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import {ReplaySubject, Subscription} from 'rxjs';
import Configuration from './Configuration';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

@Injectable()
export class StompService {
  stompCallbacks: ReplaySubject<any> = new ReplaySubject();
  stompCallbacksSubscription: Subscription | undefined = undefined;

  stompClient: any | undefined = undefined;

  constructor(@Inject('config') private config: Configuration,
              private $localStorage: LocalStorageService,
              private $sessionStorage: SessionStorageService) {
  }

  initializeWebSocketConnection(serverUrl: string = this.config.serverUrl) {
    const token = this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
    const ws = new SockJS(`${serverUrl}?access_token=${token}`);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = null;

    this.stompClient.connect({Authorization: `Bearer ${token}`}, (frame: any) => {

      this.stompCallbacksSubscription = this.stompCallbacks.subscribe(
        callback => {
          callback(this.stompClient);
        }
      );

    });
  }

  disconnect() {
    if(this.stompCallbacksSubscription && this.stompClient) {
      if (!this.stompCallbacksSubscription.closed) {
        try {
          this.stompClient.disconnect(() => {
            this.stompCallbacksSubscription?.unsubscribe();
            this.stompCallbacks = new ReplaySubject();
          });
        } catch (e) {
          console.error(e);
        }
      }
    }
  }

  register(callback: any) {
    this.stompCallbacks.next(callback);
  }

  send(topicUrl: string, data: any){
    this.stompClient.send(topicUrl, {}, JSON.stringify(data));
  }

  sendRaw(topicUrl: string, data: any){
    this.stompClient.send(topicUrl, {}, data);
  }

}

